import memoize from 'memoizee';
import config from '@/constants/config';

const getMainPools = memoize(async () => {
    const hasMainPoolsEndpoint = !!config.mainPoolsEndpoint;
    if (!hasMainPoolsEndpoint) return [];

    const { data: { poolData } } = await (await fetch(config.mainPoolsEndpoint)).json();
    return poolData;
}, {
    promise: true,
    maxAge: 60 * 1000, // 1m
});

export default getMainPools;
